export default "__VITE_ASSET__BtV99i5M__"